<template>
  <v-container justify="center">
    <v-row no-gutters justify="center">
      <v-col cols="12" xl="4" md="6">
        <h1 style="color:white; font-weight:300; text-align: center; margin:16px">A C S</h1>
        <v-card class="pa-10">
          <v-alert :value="error" type="error">{{error}}</v-alert>
          <v-row justify="center">
            <v-col cols="4" class="mb-6">
              <v-img src="/img/logo.svg"></v-img>
            </v-col>
            <v-col cols="12" >
              <v-text-field
                placeholder="Benutzername"
                outlined
                v-model="login.user"
                label="Nutzername"
              ></v-text-field>
              <v-text-field
                outlined
                password
                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show ? 'text' : 'password'"
                @click:append="show = !show"
                v-model="login.password"
                @keyup.enter.native="fireLogin"
                label="Passwort"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-card-actions class="justify-center">
            <v-btn large color="primary" @click="fireLogin">ANMELDEN</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AuthService from "@/services/AuthService";
import router from "@/plugins/router";

export default {
  runtimeCompiler: true,
  components: {},
  data: () => ({
    login: {
      user: null,
      password: null
    },
    error: null,
    show: false
  }),
  methods: {
    async fireLogin() {
      try {
        await AuthService.login(this.login);
        router.push("/");
      } catch (ex) {
        this.error = "Login Fehlgeschlagen!";

        setTimeout(() => {
          this.error = null;
        }, 2000);
      }
    }
  },
  created() {}
};
</script>

<style>
</style>